import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { BaseService } from 'src/app/shared/services/base.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { environment } from 'src/environments/environment';
import { ITheme, ThemeAssetType } from '../theme-settings/models/theme.interface';

@Injectable({
  providedIn: 'root'
})
export class SettingsDashboardService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}SettingsDashboard`;

  constructor(
    private readonly http: HttpClient,
    protected readonly toast: ToastService
  ) {
    super(toast);
  }

  createTheme(dados: ITheme): Observable<ResponseDefault<ITheme>> {
    return this.http.post<ResponseDefault<any>>(`${this.apiUrl}/themes`, dados);
  }

  listThemes(partnerId: string): Observable<ResponseDefault<ITheme[]>> {
    return this.http.get<ResponseDefault<ITheme[]>>(`${this.apiUrl}/themes/${partnerId}`);
  }

  updateTheme(themeId: string, dados: ITheme): Observable<ResponseDefault<ITheme>> {
    return this.http.put<ResponseDefault<ITheme>>(`${this.apiUrl}/theme/${themeId}`, dados);
  }

  deleteTheme(themeId: string): Observable<ResponseDefault<void>> {
    return this.http.delete<ResponseDefault<void>>(`${this.apiUrl}/theme/${themeId}`);
  }

  /** Envia o Lottie do tema; devolve o caminho no bucket, que só vale depois de salvar o tema. */
  uploadThemeAsset(themeId: string, type: ThemeAssetType, file: File): Observable<ResponseDefault<string>> {
    const form = new FormData();
    form.append('file', file);
    form.append('type', type);
    return this.http.post<ResponseDefault<string>>(`${this.apiUrl}/theme/${themeId}/assets`, form);
  }
}
